import { useMemo } from "react";

import type * as Type from "../type";

type Props = {
	serverData: Type.ServerData.ReservationListByReservationIDServerData | undefined;
};
type Result = {
	queryData: Type.QueryData.ReservationListQueryData | undefined;
};

export const useReservationListByReservationIDQueryData = ({ serverData }: Props) => {
	return useMemo(
		(): Result => ({
			queryData: serverData
				? {
						hotelName: serverData.reservationListByReservationID.hotelName,
						hotelPrefecture: serverData.reservationListByReservationID.hotelPrefecture,
						reservationList: serverData.reservationListByReservationID.reservations,
					}
				: undefined,
		}),
		[serverData],
	);
};
